import ThreeUp from './ThreeUp'

export default ThreeUp
